"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestPayload = void 0;
/* eslint-disable import/prefer-default-export */
var axios_1 = __importDefault(require("axios"));
var requestPayload = function (request) {
    var _a, _b, _c, _d;
    var data = JSON.stringify({
        challenge: request.challenge,
        country_code: request.country_code,
        payload_code: request.payload_code,
    });
    var url = 'https://29zwwlwnod.execute-api.eu-west-1.amazonaws.com/DEV/v1.0/market-specific-software';
    var headers = {
        'x-ecommerce-customer-id': '547688',
        'x-ecommerce-customer-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NTQ3Njg4LCJpYXQiOjE2NDQ4Mzk2Mzd9.gYnt_GzbYU6QndDi1EhDY5xzGddifwE1GQCXBLIi4b8',
        'x-tenant-id': 'wkhg721cursvsmo03yhixf6f7fm8qz8v'
    };
    var params = { code: '' };
    var config = {
        method: 'post',
        url: ((_a = request === null || request === void 0 ? void 0 : request.apiParams) === null || _a === void 0 ? void 0 : _a.url) ? request.apiParams.url : url,
        headers: __assign({ 'Content-Type': 'application/json' }, (((_b = request === null || request === void 0 ? void 0 : request.apiParams) === null || _b === void 0 ? void 0 : _b.headers) ? request.apiParams.headers : headers)),
        data: data,
        params: ((_c = request === null || request === void 0 ? void 0 : request.apiParams) === null || _c === void 0 ? void 0 : _c.params) ? (_d = request === null || request === void 0 ? void 0 : request.apiParams) === null || _d === void 0 ? void 0 : _d.params : params,
    };
    return (0, axios_1.default)(config)
        .then(function (res) { return res.data; })
        .catch(function (e) { return e; });
};
exports.requestPayload = requestPayload;
